import { ACTIONS_KPI_SET } from '../_constants/kpiSet.constants';

const initialState = {
  byId: {},
};

export function kpiSetReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_KPI_SET.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_KPI_SET.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_KPI_SET.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default kpiSetReducer;
